import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { checkAllInputs } from 'src/utils/checkInputs';
import { apiGlobal } from 'src/api/global';

import { ICustomerData } from 'src/environments/CheckoutConsultantAPP/interfaces';
import InputCheckout from 'src/components/functional/InputCheckout';

import { ButtonContinue, ContainerForm, ErrorMsg, SideBySide, TitleForm } from './style';

type Props = {
  customerData: ICustomerData;
  setCustomerData: Dispatch<SetStateAction<ICustomerData>>;
  setComponent: Dispatch<SetStateAction<number>>;
};

export default function PurchaseForms({
  customerData,
  setCustomerData,
  setComponent,
}: Props): JSX.Element {
  const [msgError, setMsgError] = useState('Confira os dados e tente novamente!');
  const [visibility, setVisibility] = useState('hidden');
  const [disabled, setDisabled] = useState(false);
  const [refetch, setRefetch] = useState(false);

  useEffect(() => {
    apiGlobal
      .getCep(customerData.zipCode)
      .then((getCepData) => {
        if (!getCepData.erro) {
          setCustomerData({
            ...customerData,
            neighborhood: getCepData.bairro,
            street: getCepData.logradouro,
            city: getCepData.localidade,
            state: getCepData.uf,
          });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, [refetch]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const { name, value } = event.target;
    setCustomerData({
      ...customerData,
      [name]: value,
    });
  };

  const showErrorMessage = (): void => {
    setVisibility('block');
    setTimeout(() => {
      setVisibility('hidden');
    }, 5000);
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>): void => {
    e.preventDefault();

    const message = checkAllInputs(
      customerData.customerName,
      customerData.customerCpf,
      customerData.customerPhone
    );

    if (message !== 'All inputs are valid!') {
      showErrorMessage();
      setMsgError(message);
      return;
    }

    setComponent((prev: number) => prev + 1);
    setDisabled(false);
  };

  return (
    <ContainerForm onSubmit={handleSubmit}>
      <TitleForm>
        <p>Dados da compra</p>
        <span>Verifique se os seus dados estão corretos e preencha o que estiver faltando!</span>
      </TitleForm>
      <InputCheckout
        name="customerName"
        label="Nome"
        type="text"
        value={customerData.customerName}
        onChange={handleChange}
        placeholder="Ex. Joana Mariano"
        maxLength={40}
        colorBorder={customerData.customerName !== '' ? '#000000' : '#c7c7c7'}
      />
      <InputCheckout
        name="customerEmail"
        label="Email"
        type="email"
        value={customerData.customerEmail}
        onChange={handleChange}
        placeholder="Ex. joanamariano@gmail.com"
        maxLength={40}
        colorBorder={customerData.customerEmail !== '' ? '#000000' : '#c7c7c7'}
      />
      <InputCheckout
        name="customerCpf"
        label="CPF"
        mask="999.999.999-99"
        value={customerData.customerCpf}
        onChange={handleChange}
        placeholder="Ex: 000.000.000-00"
        inputMode="numeric"
        colorBorder={customerData.customerCpf !== '' ? '#000000' : '#c7c7c7'}
      />
      <InputCheckout
        name="zipCode"
        label="CEP"
        value={customerData.zipCode}
        onChange={handleChange}
        mask="99999-999"
        inputMode="numeric"
        onBlur={() => {
          setRefetch(!refetch);
        }}
        placeholder="Ex: 00000-000"
        colorBorder={customerData.zipCode && customerData.zipCode !== '' ? '#000000' : '#c7c7c7'}
      />
      <SideBySide>
        <InputCheckout
          name="city"
          label="Cidade"
          type="text"
          inputWidth="63vw"
          value={customerData.city}
          onChange={handleChange}
          placeholder="São Paulo"
          maxLength={30}
          colorBorder={customerData.city && customerData.city !== '' ? '#000000' : '#c7c7c7'}
        />
        <InputCheckout
          name="state"
          label="Estado"
          type="text"
          inputWidth="23.666vw"
          value={customerData.state}
          onChange={handleChange}
          maxLength={2}
          placeholder="SP"
          colorBorder={customerData.state && customerData.state !== '' ? '#000000' : '#c7c7c7'}
        />
      </SideBySide>
      <InputCheckout
        name="neighborhood"
        label="Bairro"
        type="text"
        value={customerData.neighborhood}
        onChange={handleChange}
        maxLength={50}
        placeholder="Ex: Morumbi"
        colorBorder={customerData.neighborhood !== '' ? '#000000' : '#c7c7c7'}
      />
      <SideBySide>
        <InputCheckout
          name="street"
          label="Rua"
          type="text"
          inputWidth="63vw"
          value={customerData.street}
          onChange={handleChange}
          maxLength={50}
          placeholder="Ex. Juscelino kubitschek"
          colorBorder={customerData.street !== '' ? '#000000' : '#c7c7c7'}
        />
        <InputCheckout
          name="streetNumber"
          label="Número"
          inputWidth="23.666vw"
          value={customerData.streetNumber}
          onChange={handleChange}
          placeholder="Ex. 123"
          maxLength={6}
          inputMode="numeric"
          colorBorder={customerData.streetNumber !== '' ? '#000000' : '#c7c7c7'}
        />
      </SideBySide>
      <InputCheckout
        name="customerPhone"
        label="Whatsapp"
        value={customerData.customerPhone}
        onChange={handleChange}
        mask="(99) 99999-9999"
        placeholder="Ex. (11) 90000-0000"
        inputMode="numeric"
        colorBorder={customerData.customerPhone !== '' ? '#000000' : '#c7c7c7'}
      />
      <ErrorMsg visibility={visibility}>{msgError}</ErrorMsg>
      <ButtonContinue type="submit" disabled={disabled}>
        CONTINUAR
      </ButtonContinue>
    </ContainerForm>
  );
}
